/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  isProgramError,
  type Address,
  type SOLANA_ERROR__INSTRUCTION_ERROR__CUSTOM,
  type SolanaError,
} from '@solana/kit';
import { DOPPLER_LAUNCH_HOOK_V1_PROGRAM_ADDRESS } from '../programs';

/** InvalidInstructionData: Invalid instruction data */
export const DOPPLER_LAUNCH_HOOK_V1_ERROR__INVALID_INSTRUCTION_DATA = 0x1770; // 6000
/** InvalidScheduleData: Invalid schedule payload */
export const DOPPLER_LAUNCH_HOOK_V1_ERROR__INVALID_SCHEDULE_DATA = 0x1771; // 6001
/** InvalidFee: Invalid fee */
export const DOPPLER_LAUNCH_HOOK_V1_ERROR__INVALID_FEE = 0x1772; // 6002
/** InvalidDuration: Invalid fee duration */
export const DOPPLER_LAUNCH_HOOK_V1_ERROR__INVALID_DURATION = 0x1773; // 6003
/** ArithmeticOverflow: Arithmetic overflow */
export const DOPPLER_LAUNCH_HOOK_V1_ERROR__ARITHMETIC_OVERFLOW = 0x1774; // 6004
/** InvalidAuthority: Invalid hook authority */
export const DOPPLER_LAUNCH_HOOK_V1_ERROR__INVALID_AUTHORITY = 0x1775; // 6005
/** InvalidConfig: Invalid cosigner hook config */
export const DOPPLER_LAUNCH_HOOK_V1_ERROR__INVALID_CONFIG = 0x1776; // 6006
/** InvalidCosigner: Invalid cosigner key */
export const DOPPLER_LAUNCH_HOOK_V1_ERROR__INVALID_COSIGNER = 0x1777; // 6007
/** CosignerAlreadyExists: Cosigner already exists */
export const DOPPLER_LAUNCH_HOOK_V1_ERROR__COSIGNER_ALREADY_EXISTS = 0x1778; // 6008
/** CosignerNotFound: Cosigner not found */
export const DOPPLER_LAUNCH_HOOK_V1_ERROR__COSIGNER_NOT_FOUND = 0x1779; // 6009
/** CosignerListFull: Cosigner list is full */
export const DOPPLER_LAUNCH_HOOK_V1_ERROR__COSIGNER_LIST_FULL = 0x177a; // 6010

export type DopplerLaunchHookV1Error =
  | typeof DOPPLER_LAUNCH_HOOK_V1_ERROR__ARITHMETIC_OVERFLOW
  | typeof DOPPLER_LAUNCH_HOOK_V1_ERROR__COSIGNER_ALREADY_EXISTS
  | typeof DOPPLER_LAUNCH_HOOK_V1_ERROR__COSIGNER_LIST_FULL
  | typeof DOPPLER_LAUNCH_HOOK_V1_ERROR__COSIGNER_NOT_FOUND
  | typeof DOPPLER_LAUNCH_HOOK_V1_ERROR__INVALID_AUTHORITY
  | typeof DOPPLER_LAUNCH_HOOK_V1_ERROR__INVALID_CONFIG
  | typeof DOPPLER_LAUNCH_HOOK_V1_ERROR__INVALID_COSIGNER
  | typeof DOPPLER_LAUNCH_HOOK_V1_ERROR__INVALID_DURATION
  | typeof DOPPLER_LAUNCH_HOOK_V1_ERROR__INVALID_FEE
  | typeof DOPPLER_LAUNCH_HOOK_V1_ERROR__INVALID_INSTRUCTION_DATA
  | typeof DOPPLER_LAUNCH_HOOK_V1_ERROR__INVALID_SCHEDULE_DATA;

let dopplerLaunchHookV1ErrorMessages:
  | Record<DopplerLaunchHookV1Error, string>
  | undefined;
if (process.env.NODE_ENV !== 'production') {
  dopplerLaunchHookV1ErrorMessages = {
    [DOPPLER_LAUNCH_HOOK_V1_ERROR__ARITHMETIC_OVERFLOW]: `Arithmetic overflow`,
    [DOPPLER_LAUNCH_HOOK_V1_ERROR__COSIGNER_ALREADY_EXISTS]: `Cosigner already exists`,
    [DOPPLER_LAUNCH_HOOK_V1_ERROR__COSIGNER_LIST_FULL]: `Cosigner list is full`,
    [DOPPLER_LAUNCH_HOOK_V1_ERROR__COSIGNER_NOT_FOUND]: `Cosigner not found`,
    [DOPPLER_LAUNCH_HOOK_V1_ERROR__INVALID_AUTHORITY]: `Invalid hook authority`,
    [DOPPLER_LAUNCH_HOOK_V1_ERROR__INVALID_CONFIG]: `Invalid cosigner hook config`,
    [DOPPLER_LAUNCH_HOOK_V1_ERROR__INVALID_COSIGNER]: `Invalid cosigner key`,
    [DOPPLER_LAUNCH_HOOK_V1_ERROR__INVALID_DURATION]: `Invalid fee duration`,
    [DOPPLER_LAUNCH_HOOK_V1_ERROR__INVALID_FEE]: `Invalid fee`,
    [DOPPLER_LAUNCH_HOOK_V1_ERROR__INVALID_INSTRUCTION_DATA]: `Invalid instruction data`,
    [DOPPLER_LAUNCH_HOOK_V1_ERROR__INVALID_SCHEDULE_DATA]: `Invalid schedule payload`,
  };
}

export function getDopplerLaunchHookV1ErrorMessage(
  code: DopplerLaunchHookV1Error,
): string {
  if (process.env.NODE_ENV !== 'production') {
    return (
      dopplerLaunchHookV1ErrorMessages as Record<
        DopplerLaunchHookV1Error,
        string
      >
    )[code];
  }

  return 'Error message not available in production bundles.';
}

export function isDopplerLaunchHookV1Error<
  TProgramErrorCode extends DopplerLaunchHookV1Error,
>(
  error: unknown,
  transactionMessage: {
    instructions: Record<number, { programAddress: Address }>;
  },
  code?: TProgramErrorCode,
): error is SolanaError<typeof SOLANA_ERROR__INSTRUCTION_ERROR__CUSTOM> &
  Readonly<{ context: Readonly<{ code: TProgramErrorCode }> }> {
  return isProgramError<TProgramErrorCode>(
    error,
    transactionMessage,
    DOPPLER_LAUNCH_HOOK_V1_PROGRAM_ADDRESS,
    code,
  );
}
